const EvolucionPartidoIcon = ({ width = 30, height = 30, style }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            style={style}
        >
            <g fill="none">
                <path
                    fill="url(#IconifyId199d82e053e16afa90)"
                    d="M20.5 5.25a2.25 2.25 0 0 0-4.5 0v13.5a2.25 2.25 0 0 0 4.5 0z"
                />
                <path
                    fill="url(#IconifyId199d82e053e16afa91)"
                    d="M14 9.25a2.25 2.25 0 0 0-4.5 0v9.5a2.25 2.25 0 0 0 4.5 0z"
                />
                <path
                    fill="url(#IconifyId199d82e053e16afa92)"
                    d="M7.5 13.25a2.25 2.25 0 0 0-4.5 0v5.5a2.25 2.25 0 0 0 4.5 0z"
                />
                <defs>
                    <linearGradient
                        id="IconifyId199d82e053e16afa90"
                        x1="19.908"
                        x2="31.994"
                        y1="-2.529"
                        y2="3.112"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#16BBDA" />
                        <stop offset="1" stopColor="#0067BF" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId199d82e053e16afa91"
                        x1="9.934"
                        x2="20.859"
                        y1="3.58"
                        y2="10.018"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#16BBDA" />
                        <stop offset="1" stopColor="#0067BF" />
                    </linearGradient>
                    <linearGradient
                        id="IconifyId199d82e053e16afa92"
                        x1="2.719"
                        x2="11.477"
                        y1="5.375"
                        y2="12.6"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#16BBDA" />
                        <stop offset="1" stopColor="#0067BF" />
                    </linearGradient>
                </defs>
            </g>
        </svg>
    );
};

export default EvolucionPartidoIcon;
